import { laxinAwardInfo, laxinGiveAwards } from '../../../../api/laxin'
import { isArray } from '../../../../utils/xp.v1'

export default {
  async loadAwardInfo({ state, dispatch }, { awardId }) {
    await dispatch('account/readAccount', {}, {root: true})
    state.awardId = awardId > 0 ? +awardId : 0
    const R = await laxinAwardInfo({ awardId })
    state.curAward = R.awardInfo || null
    dispatch('laxin/mergeUsers', R.userInfosMap, { root: true })
    // eslint-disable-next-line
  },

  async loadGiveAwards({ state, dispatch }) {
    await dispatch('account/readAccount', {}, {root: true})
    const R = await laxinGiveAwards()
    state.giveAwards = isArray(R.gAwardList) ? R.gAwardList : []
    dispatch('laxin/mergeUsers', R.userInfosMap, { root: true })
  },

  async bind({ dispatch, getters }) {
    const { awardId, giveUid } = getters
    if (awardId > 0 && giveUid > 0) {
      dispatch(
        'laxin/bind',
        { srcUid: giveUid, bindType: 1, refId: awardId },
        { root: true }
      )
    }
  }
}
